import * as React from 'react';

import Tabs from 'antd/lib/tabs';
import {useHistory} from 'react-router';

const AreaPageMobileNav = (props) => {
	const history = useHistory();
	const {currentAreaUrl, activeTab, additionalClass} = props;
	const { TabPane } = Tabs;
	return (
		<Tabs
			className={additionalClass ? `top-page__mobile-nav ${additionalClass}` : 'top-page__mobile-nav'}
			defaultActiveKey="1"
			onTabClick={(key, event) => {
				history.push(`${currentAreaUrl}/${key}`);
			}}
			activeKey={activeTab}
		>
			<TabPane tab="About"  key="about" />
			<TabPane tab="Pricing & Services" key="services" />
			<TabPane tab="Veterinarians" key="veterinarians" />
			<TabPane tab="Local Resources" key="resources" />
			<TabPane tab="Pet Memorial Keepsakes" key="keepsakes" />
		</Tabs>
	);
};

export default AreaPageMobileNav;